(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Collection', 'torso/modules/NestedModel', 'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/Collection'), require('backbone-torso/modules/NestedModel'), require('./../urls'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoCollection, TorsoNestedModel, urls) {
  'use strict';

  /**
   * @class surveyResponseCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: TorsoNestedModel,
    url: urls.surveyResponseExtService,
    fetchHttpAction: 'POST'
  }))();
}));
